export const FETCH_FEATURED_MATERIAL_REQUESTED =
  "FETCH_FEATURED_MATERIAL_REQUESTED"
export const FETCH_FEATURED_MATERIAL_SUCCESSFUL =
  "FETCH_FEATURED_MATERIAL_SUCCESSFUL"
export const FETCH_FEATURED_MATERIAL_FAILED = "FETCH_FEATURED_MATERIAL_FAILED"
export const FETCH_TOP_COURSES_REQUESTED = "FETCH_TOP_COURSES_REQUESTED"
export const FETCH_TOP_COURSES_SUCCESSFUL = "FETCH_TOP_COURSES_SUCCESSFUL"
export const FETCH_TOP_COURSES_FAILED = "FETCH_TOP_COURSES_FAILED"
